export const countPercent = (count: number, totalCount: number) =>
    (100 * count) / (totalCount || 1) || 0;
